let openQuicksearchButton = document.querySelector(".not-sv");

if(openQuicksearchButton) {
    openQuicksearchButton.addEventListener("click", function() {
        document.querySelector("#quicksearch").classList.toggle("show");
    });
}